import { render, staticRenderFns } from "./TenantInfo.vue?vue&type=template&id=4bb6eeb2&scoped=true&"
import script from "./TenantInfo.vue?vue&type=script&lang=js&"
export * from "./TenantInfo.vue?vue&type=script&lang=js&"
import style0 from "./TenantInfo.vue?vue&type=style&index=0&id=4bb6eeb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb6eeb2",
  null
  
)

export default component.exports